import { ENTITY_NAMES as e } from "@frontends/util-entity-config";
import { createContext as t, useCallback as n, useContext as r, useEffect as i, useLayoutEffect as a, useMemo as o, useRef as s, useState as c, useSyncExternalStore as l } from "react";
import { getCookie as u, setCookie as d } from "@frontends/util-utils";
import { jsx as f } from "react/jsx-runtime";
//#region src/lib/constants.ts
var p = "theme", m = "theme", h = "(prefers-color-scheme: dark)", g = "--theme-color", _ = e, v = {
	tradequo: "TradeQuo",
	quomarkets: "QuoMarkets"
}, y = "/brand";
//#endregion
//#region src/lib/brand.ts
function b(e) {
	return _.some((t) => t === e);
}
function x(e) {
	typeof document > "u" || (document.documentElement.dataset.brand = e);
}
function S(e, t, n) {
	return `${y}/${e}/logo-${t}-${n}.svg`;
}
function C(e) {
	return `${y}/${e}/favicon.png`;
}
//#endregion
//#region src/lib/context/ThemeContext.ts
var w = t(null);
//#endregion
//#region src/lib/hooks/useTheme.ts
function T() {
	let e = r(w);
	if (!e) throw Error("useTheme must be used within a ThemeProvider");
	return e;
}
//#endregion
//#region src/lib/themeMode.ts
function E(e) {
	return e === "light" || e === "dark";
}
function D(e) {
	return e === "light" || e === "dark" || e === "system";
}
function O(e, t) {
	return e === "system" ? t ? "dark" : "light" : e;
}
//#endregion
//#region src/lib/address.ts
function k() {
	if (typeof window > "u") return null;
	let e = new URLSearchParams(window.location.search).get(m);
	return D(e) ? e : null;
}
function A() {
	if (k() === null) return;
	let e = new URL(window.location.href);
	e.searchParams.delete(m), window.history.replaceState(window.history.state, document.title, e.pathname + e.search + e.hash);
}
//#endregion
//#region src/lib/hooks/useSystemPrefersDark.ts
function j() {
	return typeof window < "u" && typeof window.matchMedia == "function";
}
function M() {
	return j() && window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function N() {
	return !1;
}
function P(e) {
	if (!j()) return () => void 0;
	let t = window.matchMedia(h);
	if (typeof t.addEventListener == "function") return t.addEventListener("change", e), () => t.removeEventListener("change", e);
	let n = t;
	return n.addListener(e), () => n.removeListener(e);
}
function F() {
	return l(P, M, N);
}
//#endregion
//#region src/lib/initialThemeMode.ts
function I(e, t) {
	if (typeof window > "u") return e;
	let n = k();
	if (n) return n;
	let r = u(t);
	return D(r) ? r : e;
}
//#endregion
//#region src/lib/paintDocument.ts
function L(e) {
	e.style.removeProperty("background-color");
}
function R(e) {
	let t = getComputedStyle(e).getPropertyValue(g).trim();
	if (!t) return;
	let n = document.querySelector("meta[name=\"theme-color\"]");
	n && (n.content = t);
}
function z(e) {
	let t = document.documentElement;
	t.classList.remove("light", "dark"), t.classList.add(e), L(t), R(t);
}
//#endregion
//#region src/lib/providers/ThemeProvider.tsx
function B({ mode: e, onModeChange: t, defaultMode: r = "system", storageKey: l = p, children: u }) {
	let m = e !== void 0, [h, g] = c(() => m ? r : I(r, l)), _ = e ?? h, v = s(t);
	a(() => {
		v.current = t;
	}, [t]);
	let y = O(_, F());
	i(() => {
		m || A();
	}, [m]), a(() => {
		z(y);
	}, [y]), i(() => {
		m || d(l, _);
	}, [
		m,
		_,
		l
	]);
	let b = n((t) => {
		v.current?.(t), e === void 0 && g(t);
	}, [e]), x = o(() => ({
		themeMode: _,
		setThemeMode: b,
		resolvedMode: y
	}), [
		_,
		b,
		y
	]);
	return /* @__PURE__ */ f(w.Provider, {
		value: x,
		children: u
	});
}
//#endregion
//#region src/lib/setFavicon.ts
var V = "brand-favicon";
function H(e) {
	if (typeof document > "u") return;
	let t = document.getElementById(V);
	t || (t = document.createElement("link"), t.id = V, t.rel = "icon", document.head.appendChild(t)), t.href = e;
}
//#endregion
export { _ as BRANDS, v as BRAND_TITLES, B as ThemeProvider, C as getBrandFaviconUrl, S as getBrandLogoUrl, b as isBrand, E as isResolvedMode, D as isThemeMode, x as setBrand, H as setFavicon, T as useTheme };
